import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { RemoveIcon } from '@app-velocity/icons';
import { MessageBus } from '@app-velocity/message-bus';

const StyledButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  background: 'none',
  padding: 0,
  border: 'none',
  fontWeight: 500,
  fontSize: 12,
  color: 'var(--text-text-secondary-color)',
  svg: {
    fill: 'var(--text-text-secondary-color)',
  },
  cursor: 'pointer',
  '&:hover': {
    color: 'var(--error-error-icon-primary-color)',
    svg: {
      fill: 'var(--error-error-icon-primary-color)',
    },
  },
}));

const messageBus = new MessageBus('prototypes');

export type RemoveFigmaReportButtonProps = {
  id: string;
};

export const RemoveFigmaReportButton = ({
  id,
}: RemoveFigmaReportButtonProps) => {
  const { t } = useI18n();

  const onClick = () => {
    messageBus.publish('modal:delete-figma-report:open', { id });
  };

  return (
    <StyledButton onClick={onClick}>
      <RemoveIcon />
      {t('shared:delete')}
    </StyledButton>
  );
};
